import { EABFilterImplementationType, type FilterOption } from "@/graphql";
import type { ActionFilter, EventFilter } from "../FilterTypes";
import DescriptionDraftFilterUI from "../ui/DescriptionDraftFilterUI.vue";
import DescriptionFilterBadge from "@/components/event-action/filter/ui/badges/DescriptionFilterBadge.vue";

export default class DescriptionDraftFilter implements EventFilter, ActionFilter {
  constructor(
    public readonly searchText: string,
    public readonly isNegated?: boolean,
  ) {}

  static readonly UI = DescriptionDraftFilterUI;

  static readonly Badge = DescriptionFilterBadge;

  private getFilter(): FilterOption {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_ACTION_FREE_TEXT,
        value: {
          value: this.searchText,
          negated: this.isNegated ?? false,
        },
      },
    };
  }

  getEventFilter(): FilterOption {
    return this.getFilter();
  }

  getActionFilter(): FilterOption {
    return this.getFilter();
  }
}
